import PersonBubble from '../src/PersonBubble';
export default PersonBubble;
